import { useState } from "react";
import { useParams } from "react-router-dom";
import TrackMap from "./TrackMap";
import ElevationChart from "./ElevationChart";
import { usePositions } from "./usePositions";

export default function TripView() {
  const { user, trip } = useParams<{ user: string; trip: string }>();
  const { positions, status } = usePositions(user!, trip!);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ flex: "0 0 70%", position: "relative", overflow: "hidden" }}>
        <TrackMap
          positions={positions}
          hoveredIndex={hoveredIndex}
          onHover={setHoveredIndex}
          status={status}
        />
      </div>
      <div style={{ flex: "0 0 30%", borderTop: "1px solid #ccc", overflow: "hidden" }}>
        <ElevationChart
          positions={positions}
          hoveredIndex={hoveredIndex}
          onHover={setHoveredIndex}
        />
      </div>
    </div>
  );
}
